import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=03cda022&scoped=true&"
import script from "./NotFound.vue?vue&type=script&lang=ts&"
export * from "./NotFound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cda022",
  null
  
)

export default component.exports